import { render, staticRenderFns } from "./SimilaritySummaryTable.vue?vue&type=template&id=37458297&scoped=true&"
import script from "./SimilaritySummaryTable.vue?vue&type=script&lang=js&"
export * from "./SimilaritySummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37458297",
  null
  
)

export default component.exports